var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative" },
    [
      _vm.checkPermi(["merchant:product:page:list"])
        ? _c(
            "el-card",
            {
              staticClass: "ivu-mt",
              attrs: {
                bordered: false,
                shadow: "never",
                "body-style": { padding: 0 },
              },
            },
            [
              _c(
                "div",
                { staticClass: "padding-add" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: "",
                        size: "small",
                        "label-position": "right",
                      },
                      nativeOn: {
                        submit: function ($event) {
                          $event.preventDefault()
                        },
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "关键字：" } },
                        [
                          _c("el-input", {
                            staticClass: "form_content_width",
                            attrs: {
                              placeholder: "请输入搜索内容",
                              size: "small",
                              clearable: "",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handleSeachList($event)
                              },
                            },
                            model: {
                              value: _vm.keyword,
                              callback: function ($$v) {
                                _vm.keyword =
                                  typeof $$v === "string" ? $$v.trim() : $$v
                              },
                              expression: "keyword",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "房型：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                clearable: "",
                                size: "small",
                                placeholder: "请选择房型",
                              },
                              on: { change: _vm.handleSeachList },
                              model: {
                                value: _vm.tableFrom.categoryId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.tableFrom, "categoryId", $$v)
                                },
                                expression: "tableFrom.categoryId",
                              },
                            },
                            _vm._l(
                              _vm.roomTypeOptions.roomTypeList,
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "床型：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                clearable: "",
                                size: "small",
                                placeholder: "请选择床型",
                              },
                              on: { change: _vm.handleSeachList },
                              model: {
                                value: _vm.tableFrom.productType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.tableFrom, "productType", $$v)
                                },
                                expression: "tableFrom.productType",
                              },
                            },
                            _vm._l(
                              _vm.roomTypeOptions.bedTypeList,
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "small" },
                              on: { click: _vm.handleSeachList },
                            },
                            [_vm._v("查询")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: { click: _vm.handleReset },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: "0 20px 20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "hasPermi",
                  rawName: "v-hasPermi",
                  value: ["merchant:product:save"],
                  expression: "['merchant:product:save']",
                },
              ],
              staticClass: "mt16 mr14",
              attrs: { size: "small", type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.handleAdd("isAdd")
                },
              },
            },
            [_vm._v("新增")]
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "mt20",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData.data,
                size: "small",
                "highlight-current-row": true,
                "highlight-current-row": "",
              },
              on: {
                "selection-change": _vm.handleSelectionChange,
                "select-all": _vm.selectAll,
                select: _vm.selectOne,
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _vm.checkedCities.includes("ID")
                ? _c("el-table-column", {
                    attrs: { prop: "id", label: "ID", "min-width": "50" },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("房型名称")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "roomTypeName",
                      label: "房型名称",
                      "min-width": "90",
                      "show-overflow-tooltip": true,
                    },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("酒店分类")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "cateName",
                      label: "酒店分类",
                      "min-width": "90",
                    },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("展示图")
                ? _c("el-table-column", {
                    attrs: { label: "展示图", "min-width": "80" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "demo-image__preview line-heightOne",
                                },
                                [
                                  _c("el-image", {
                                    attrs: {
                                      src: scope.row.flatPattern,
                                      "preview-src-list": [
                                        scope.row.flatPattern,
                                      ],
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3659067582
                    ),
                  })
                : _vm._e(),
              _vm.checkedCities.includes("售价")
                ? _c("el-table-column", {
                    attrs: { prop: "price", label: "售价", "min-width": "90" },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("面积")
                ? _c("el-table-column", {
                    attrs: { prop: "area", label: "面积", "min-width": "90" },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("床型")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "bedType",
                      label: "床型",
                      "min-width": "90",
                    },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("窗户")
                ? _c("el-table-column", {
                    attrs: { prop: "window", label: "窗户", "min-width": "90" },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("WIFI")
                ? _c("el-table-column", {
                    attrs: { prop: "wifi", label: "WIFI", "min-width": "90" },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("禁烟")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "smokingCondition",
                      label: "禁烟",
                      "min-width": "90",
                    },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("房间数")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "quantity",
                      label: "房间数",
                      "min-width": "90",
                    },
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { width: "190", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.tableFrom.type !==
                          _vm.ProductTypeEnum.InTheWarehouse &&
                        _vm.tableFrom.type !==
                          _vm.ProductTypeEnum.AlertInventory &&
                        _vm.tableFrom.type !==
                          _vm.ProductTypeEnum.PendingReview &&
                        _vm.checkPermi(["merchant:product:info"])
                          ? [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      path:
                                        "/hotel/list/creatProduct/" +
                                        scope.row.id +
                                        "/1/2/0",
                                    },
                                  },
                                },
                                [_vm._v(" 详情 ")]
                              ),
                            ]
                          : _vm._e(),
                        _vm.checkPermi(["merchant:product:submit:audit"]) &&
                        _vm.tableFrom.type === _vm.ProductTypeEnum.PendingReview
                          ? [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.handlePendingReview(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("提交审核")]
                              ),
                            ]
                          : _vm._e(),
                        _vm.tableFrom.type !== "5" &&
                        _vm.tableFrom.type !== "6" &&
                        _vm.checkPermi(["merchant:product:update"])
                          ? [
                              _vm.tableFrom.type !== "2" &&
                              _vm.tableFrom.type !== "4"
                                ? _c("el-divider", {
                                    attrs: { direction: "vertical" },
                                  })
                                : _vm._e(),
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.onEdit(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("编辑")]
                              ),
                            ]
                          : _vm._e(),
                        [
                          _c("el-divider", {
                            attrs: { direction: "vertical" },
                          }),
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.handleGenerateInventory(scope.row)
                                },
                              },
                            },
                            [_vm._v("生成库存")]
                          ),
                        ],
                        (_vm.tableFrom.type === _vm.ProductTypeEnum.OnSale ||
                          (_vm.tableFrom.type ===
                            _vm.ProductTypeEnum.AlertInventory &&
                            scope.row.isShow) ||
                          (_vm.tableFrom.type === _vm.ProductTypeEnum.SoldOut &&
                            scope.row.isShow)) &&
                        _vm.checkPermi(["merchant:product:quick:stock:add"])
                          ? [
                              _c("el-divider", {
                                attrs: { direction: "vertical" },
                              }),
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleEdit(scope.row, true)
                                    },
                                  },
                                },
                                [_vm._v("编辑面积")]
                              ),
                            ]
                          : _vm._e(),
                        (_vm.tableFrom.type === _vm.ProductTypeEnum.Audit ||
                          _vm.tableFrom.type ===
                            _vm.ProductTypeEnum.ReviewFailed ||
                          _vm.tableFrom.type ===
                            _vm.ProductTypeEnum.RecycleBin) &&
                        _vm.checkPermi(["merchant:product:delete"])
                          ? [
                              _c("el-divider", {
                                attrs: { direction: "vertical" },
                              }),
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleDelete(
                                        scope.row.id,
                                        _vm.tableFrom.type
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.tableFrom.type === "5"
                                        ? "删除"
                                        : "加入回收站"
                                    )
                                  ),
                                ]
                              ),
                            ]
                          : _vm._e(),
                        _vm.tableFrom.type === _vm.ProductTypeEnum.PendingReview
                          ? [
                              _c("el-divider", {
                                attrs: { direction: "vertical" },
                              }),
                              _c(
                                "el-dropdown",
                                {
                                  attrs: { size: "small", trigger: "click" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (dropdown) {
                                          return _c(
                                            "el-dropdown-menu",
                                            {},
                                            [
                                              _vm.checkPermi([
                                                "merchant:product:info",
                                              ])
                                                ? _c(
                                                    "el-dropdown-item",
                                                    {
                                                      staticClass: "infoItem",
                                                      nativeOn: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleInfo(
                                                            scope.row.id,
                                                            scope.row.type
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("详情 ")]
                                                  )
                                                : _vm._e(),
                                              _vm.checkPermi([
                                                "merchant:product:delete",
                                              ])
                                                ? _c(
                                                    "el-dropdown-item",
                                                    {
                                                      nativeOn: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleDelete(
                                                            scope.row.id,
                                                            _vm.tableFrom.type
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.tableFrom.type ===
                                                            "5"
                                                            ? "删除"
                                                            : "加入回收站"
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "el-dropdown-link" },
                                    [
                                      _vm._v(" 更多"),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-arrow-down el-icon--right",
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          : _vm._e(),
                        _vm.tableFrom.type ===
                          _vm.ProductTypeEnum.InTheWarehouse ||
                        _vm.tableFrom.type ===
                          _vm.ProductTypeEnum.AlertInventory ||
                        (_vm.operation && !scope.row.isShow)
                          ? [
                              _c("el-divider", {
                                attrs: { direction: "vertical" },
                              }),
                              _c(
                                "el-dropdown",
                                {
                                  attrs: { size: "small", trigger: "click" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (dropdown) {
                                          return _c(
                                            "el-dropdown-menu",
                                            {},
                                            [
                                              (_vm.tableFrom.type === "2" ||
                                                _vm.tableFrom.type === "4") &&
                                              _vm.checkPermi([
                                                "merchant:product:info",
                                              ])
                                                ? _c(
                                                    "el-dropdown-item",
                                                    {
                                                      staticClass: "infoItem",
                                                      nativeOn: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleInfo(
                                                            scope.row.id,
                                                            scope.row.type
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("详情 ")]
                                                  )
                                                : _vm._e(),
                                              _vm.checkPermi([
                                                "merchant:product:set:freight:template",
                                              ]) &&
                                              scope.row.type !== 5 &&
                                              scope.row.type !== 6
                                                ? _c(
                                                    "el-dropdown-item",
                                                    {
                                                      nativeOn: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleSetFreight(
                                                            scope.row
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("设置运费")]
                                                  )
                                                : _vm._e(),
                                              _vm.checkPermi([
                                                "merchant:product:set:brokerage",
                                              ])
                                                ? _c(
                                                    "el-dropdown-item",
                                                    {
                                                      nativeOn: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleSetCommission(
                                                            scope.row
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("设置佣金")]
                                                  )
                                                : _vm._e(),
                                              _vm.checkPermi([
                                                "merchant:product:add:feedback:coupons",
                                              ])
                                                ? _c(
                                                    "el-dropdown-item",
                                                    {
                                                      nativeOn: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleAddCoupon(
                                                            scope.row
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("添加回馈券")]
                                                  )
                                                : _vm._e(),
                                              _vm.checkPermi([
                                                "merchant:product:delete",
                                              ])
                                                ? _c(
                                                    "el-dropdown-item",
                                                    {
                                                      nativeOn: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleDelete(
                                                            scope.row.id,
                                                            _vm.tableFrom.type
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.tableFrom.type ===
                                                            "5"
                                                            ? "删除"
                                                            : "加入回收站"
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "el-dropdown-link" },
                                    [
                                      _vm._v(" 更多"),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-arrow-down el-icon--right",
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "page-sizes": _vm.$constants.page.limit,
                  "page-size": _vm.tableFrom.limit,
                  "current-page": _vm.tableFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.card_select_show,
                  expression: "card_select_show",
                },
              ],
              staticClass: "card_abs",
            },
            [
              [
                _c(
                  "div",
                  { staticClass: "cell_ht" },
                  [
                    _c(
                      "el-checkbox",
                      {
                        attrs: { indeterminate: _vm.isIndeterminate },
                        on: { change: _vm.handleCheckAllChange },
                        model: {
                          value: _vm.checkAll,
                          callback: function ($$v) {
                            _vm.checkAll = $$v
                          },
                          expression: "checkAll",
                        },
                      },
                      [_vm._v("全选")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.checkSave()
                          },
                        },
                      },
                      [_vm._v("保存")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-checkbox-group",
                  {
                    on: { change: _vm.handleCheckedCitiesChange },
                    model: {
                      value: _vm.checkedCities,
                      callback: function ($$v) {
                        _vm.checkedCities = $$v
                      },
                      expression: "checkedCities",
                    },
                  },
                  _vm._l(_vm.columnData, function (item) {
                    return _c(
                      "el-checkbox",
                      {
                        key: item,
                        staticClass: "check_cell",
                        attrs: { label: item },
                      },
                      [_vm._v(_vm._s(item))]
                    )
                  }),
                  1
                ),
              ],
            ],
            2
          ),
        ],
        1
      ),
      _c("room-tpye", {
        ref: "productTpye",
        attrs: { addType: _vm.addType },
        on: { success: _vm.handleSuccess },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }